module.exports = __webpack_public_path__ + "img/20210127_150500.4fa723fc.jpg";